import SettingsService from 'phoenix/services/settingsService';

/**
* @ngdoc service
* @name  phoenix.pxEnvironmentService
* 
* @description 
* A service provides details about the user environment
* 
**/
export class EnvironmentService {
	public static $inject = [
		'$window',
		'$http',
		'$state',
		'settingsService'
	];

	constructor(
		private $window:ng.IWindowService,
		private $http:ng.IHttpService,
		private $state:ng.ui.IStateService,
		private settingsService:SettingsService
	) {
	}

	/**
	* @ngdoc property
	* @name pxEnvironmentService#baseUrl
	* @propertyOf phoenix.pxEnvironmentService
	* @kind property
	*
	* @description
	* Returns the full url to the left of the hash and includes a trailing slash
	*/
	public get baseUrl() {
		let webPath = this.$window.location.href.split('#')[0];
		if (webPath.lastIndexOf('/') !== webPath.length - 1) {
			webPath = webPath.concat('/');
		}

		return webPath;
	}

	private _language:string;
	/**
	* @ngdoc property
	* @name pxEnvironmentService#language
	* @propertyOf phoenix.pxEnvironmentService
	* @kind property
	*
	* @description
	* Returns the current active language
	*/
	public get language() {
		return this._language;
	}
	/**
	 * @ngdoc property
	 * @name pxEnvironmentService#helpLanguage
	 * @propertyOf phoenix.pxEnvironmentService
	 * @kind property
	 * 
	 * @description
	 * The target language for what legal files to link to.
	 */
	public legalLanguage = '';
	/**
	 * @ngdoc property
	 * @name pxEnvironmentService#helpLanguage
	 * @propertyOf phoenix.pxEnvironmentService
	 * @kind property
	 * 
	 * @description
	 * The target language for what help files to link to.
	 */
	public helpLanguage = '';
	/**
	* @ngdoc property
	* @name pxEnvironmentService#touchEnabled
	* @propertyOf phoenix.pxEnvironmentService
	* @kind property
	*
	* @description
	* Returns the availability of touch events
	*/
	public get touchEnabled() {
		return ('ontouchstart' in this.$window) || 
			this.$window.navigator['MaxTouchPoints'] > 0 || 
			this.$window.navigator.msMaxTouchPoints > 0;
	}
	/**
	* @ngdoc property
	* @name pxEnvironmentService#timeZone
	* @propertyOf phoenix.pxEnvironmentService
	* @kind property
	*
	* @description
	* Returns the current timezone
	*/
	public get timeZone() {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	}
	/**
	* @ngdoc property
	* @name pxEnvironmentService#isIE
	* @propertyOf phoenix.pxEnvironmentService
	* @kind property
	*
	* @description
	* Returns if the browser is Internet Explorer
	*/
	public isIE = this.$window.navigator.userAgent.indexOf('Trident') > -1;
	/**
	* @ngdoc property
	* @name pxEnvironmentService#isEdge
	* @propertyOf phoenix.pxEnvironmentService
	* @kind property
	*
	* @description
	* Returns if the browser is Windows Edge Browser
	*/
	public isEdge = this.$window.navigator.userAgent.indexOf('Edge/') > -1;
	/**
	 * @ngdoc property
	 * @name pxEnvironmentService#isInShell
	 * @propertyOf phoenix.pxEnvironmentService
	 * @kind property
	 * 
	 * @description
	 * Returns if the browser is in the HSI Mobile Shell
	 */
	public isInShell = this.$window.navigator.userAgent.indexOf('hsi-mobile-shell') > -1;
	/**
	 * @ngdoc property
	 * @name pxEnvironmentService#helpLanguage
	 * @propertyof phoenix.pxEnvironmentService
	 * @kind property
	 *
	 * @description
	 * Returns true if the application is running on windows
	 */
	public isWindows = this.$window.navigator.platform === 'Win32' || this.$window.navigator.platform === 'Win64';
	/**
	 * @ngdoc property
	 * @name pxEnvironmentService#isTopLevel
	 * @propertyOf phoenix.pxEnvironmentService
	 * @kind property
	 * 
	 * @description
	 * Returns if the current context is one of the predefined top level contexts 
	 */
	public get isTopLevel() {
		return this.$state.current.data ? this.$state.current.data.isTopLevel : false;
	}
	/**
	* @ngdoc method
	* @name pxEnvironmentService#loadLanguages
	* @propertyOf phoenix.pxEnvironmentService
	* @kind method
	*
	* @description
	* Loads the current current language
	*
	* @returns {Deferred} A promise that will resolve with the
	* language to use.
	*/
	public loadLanguages() {
		return this.$http.get<{useLangFile:string}>(`${this.settingsService.serverAPIPath}/languages`)
			.then(response => {
				this._language = response.data.useLangFile;
				return response.data.useLangFile;
			});
	}
}



// WEBPACK FOOTER //
// ./src/phoenix/services/environmentService.ts